import { FC, useState, KeyboardEventHandler, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { merge } from '../../utils/utility';
import { Button } from '../button/Button';
import { TextInput } from '../form/TextInput';
import strings from './file.translations';

interface Props {
  showButton?: boolean;
  className?: string;
  initialTerm?: string;
  placeholder?: string;
}

export const SearchBar: FC<Props> = ({
  showButton = true,
  className,
  initialTerm,
  placeholder = strings.common.search
}) => {
  const [searchTerm, setSearchTerm] = useState<string>(initialTerm || '');

  useEffect(() => {
    setSearchTerm(initialTerm || '');
  }, [setSearchTerm, initialTerm]);

  const navigate = useNavigate();
  const onSearch = () => {
    navigate(`/documents/search/${searchTerm}`);
  };

  const keyHandler: KeyboardEventHandler<HTMLElement> = event => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className={merge(className, 'flex gap-2 items-stretch')}>
      <TextInput
        onChange={setSearchTerm}
        value={searchTerm}
        clearable
        Icon={FaSearch}
        placeholder={placeholder}
        containerClassName="flex-1"
        onKeyDown={keyHandler}
      />
      {showButton && (
        <Button className="w-24" primary onClick={onSearch}>
          {strings.common.search}
        </Button>
      )}
    </div>
  );
};
